import React from 'react';

import GroupsScreen from './GroupsScreen';

export const ActivateGroupsScreen = (props: any) => (
  <GroupsScreen {...props} activate={true} key="activate" />
);

export default ActivateGroupsScreen;
